<template>
  <div>
    <div class="jumbotron">
      <div class="btn-group pull-right" role="group" aria-label="">
        <button type="button" class="btn btn-sm btn-primary" @click="newForm">
          <i class="fas fa-plus-circle"></i> New Deployment
        </button>
      </div>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#/home">Home</a></li>
        <li class="breadcrumb-item active">Scheduled Deployments</li>
      </ol>
      <div class="row">
        <div class="col-md-4">
          <div class="card card-inverse card-info text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Inspect a scheduled deployment</p>
              </blockquote>
              <i aria-hidden="true" class="fas fa-info-circle card-block-watermark"></i>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-inverse card-warning text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Update a scheduled deployment</p>
              </blockquote>
              <i aria-hidden="true" class="fas fa-edit card-block-watermark"></i>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card card-inverse card-success text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Resolve or remove a scheduled deployment</p>
              </blockquote>
              <i aria-hidden="true" class="fas fa-minus-circle card-block-watermark"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :v-if="modalInfoShow"
      :show.sync="modalInfoShow"
      :backdrop="modalBackdrop"
      effect="zoom"
      large>
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title" v-if="selection">
          <i class="fa fa-rocket" aria-hidden="true"></i>
           Deployment for {{selection.releaseName}}
           <span class="badge badge-default badge-pill">{{selection.id}}</span>
        </h4>
      </div>
      <div slot="modal-body" class="modal-body">
        <ul class="list-group" v-if="selection">
          <li class="list-group-item justify-content-between">
            <label class="col-form-label">Dev Team</label>
            <span class="info-form col-12">{{selection.team}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            <label class="col-form-label">Jira Project</label>
            <span class="info-form col-12">{{selection.jiraProject}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            <label class="col-form-label">Helium App Names</label>
            <span class="info-form col-12">{{selection.appNames}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            <label class="col-form-label">Helium App IDs</label>
            <span class="info-form col-12">{{selection.appIds}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            <label class="col-form-label">Data Source</label>
            <span class="info-form col-12">{{selection.dataSource.heliumDataSourceName}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            <label class="col-form-label">Host Name</label>
            <span class="info-form col-12">{{selection.dataSource.hostname}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            <label class="col-form-label">Database</label>
            <span class="info-form col-12">{{selection.dataSource.dbName}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            <label class="col-form-label">Helium App Schemas</label>
            <span class="info-form col-12">{{selection.appSchemas}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            <label class="col-form-label">Helium Release Group</label>
            <span class="info-form col-12">{{selection.releaseGroup}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            <label class="col-form-label">Helium Release Name</label>
            <span class="info-form col-12">{{selection.releaseName}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            <label class="col-form-label">Helium Release Description</label>
            <span class="info-form col-12">{{selection.releaseDescription}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            <label class="col-form-label">Bitbucket URL</label>
            <span class="info-form col-12">{{selection.releaseTag}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            <label class="col-form-label">Deployment Instructions</label>
            <span class="info-form col-12">{{selection.instructions}}</span>
          </li>
          <li class="list-group-item justify-content-between">
            <label class="col-form-label">Deployment Date</label>
            <span class="info-form col-12">{{selection.deploymentDate}}</span>
          </li>
        </ul>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" v-on:click="modalInfoClose">Close</button>
      </div>
    </modal>
    <modal title="Schedule Deployment" large :show.sync="showForm" :backdrop="modalBackdrop">
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
        </h4>
      </div>
      <div slot="modal-body" class="modal-body">
        <form-wizard ref="deploymentWizard" @on-complete="mergeSchedule()" color="#3498db"
        :title =wizardTitle subtitle="based on a Helium Release" error-color="#e74c3c" @on-error="handleErrorMessage" @on-validate="handleValidation">
              <div class="loader" v-if="loadingWizard"></div>
            <tab-content title="Select Helium Apps" :before-change="validateStep1 ">
                  <div class="form-group">
                    <div class="input-group">
                      <label class="col-4 col-form-label">Data Source *</label>
                      <select
                        v-model="selectedDataSource"
                        name="dataSource"
                        type="text"
                        placeholder="Data Source"
                        class="custom-select form-control"
                        >
                          <option disabled value="Please select a Data Source">Please select a Data Source</option>
                          <option v-for="entry in dataSources" v-bind:value="entry.dataSource">{{ entry.heliumDataSourceName }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input-group">
                      <label class="col-4 col-form-label">Developer Team *</label>
                      <select
                        v-model="selectedTeam"
                        name="team"
                        type="text"
                        placeholder="Team"
                        class="custom-select form-control">
                          <option disabled value="Please select a team">Please select a Dev Team</option>
                          <option v-for="team in teams">{{ team }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="input-group">
                      <label class="col-4 col-form-label">JIRA Project *</label>
                      <select
                        v-model="selectedProject"
                        name="project"
                        type="text"
                        placeholder="JIRA Project"
                        class="custom-select form-control">
                          <option disabled value="">Please select a JIRA Project</option>
                          <option v-for="jiraProject in jiraProjects">{{ jiraProject }}</option>
                      </select>
                    </div>
                    <small class="form-text text-muted text-left col-sm-4">Please select the Dev Team before selecting the JIRA Project.</small>
                  </div>
                  <div class="row">
                    <div class="col">
                      <vue-good-table ref="heliumAppsTable"
                        @on-select-all="onSelectAll"
                        @on-row-click="onRowClick"
                        :paginationOptions="{
                          enabled: true
                        }"
                        :sort-options="{
                          enabled: true,
                          initialSortBy: {field: 'name', type: 'asc'}
                        }"
                        :select-options="{ enabled: true }"
                        styleClass="vgt-table striped bordered table-hover"
                        :columns="heliumAppColumns"
                        :rows="heliumApps"
                        >
                      </vue-good-table>
                    </div>
                  </div>
            </tab-content>
            <tab-content title="Fill in Release Details"
                         :before-change="validateStep2">
                  <div class="form-group">
                    <div class="input-group">
                      <label class="col-4 col-form-label">Bitbucket URL *</label>
                      <input
                        v-model="releaseTag"
                        name="releaseTag"
                        class="form-control"
                        type="text"
                        placeholder="Bitbucket URL"
                        >
                    </div>
                    <small class="form-text text-muted text-left col-sm-4">Syntax: https://bitbucket.org/mezzanineapps/
                    {repository}/commits/tag/ DEPLOY_{releaseGroup}_{YYYYMMDD}</small>
                  </div>
                  <div class="form-group"> 
                    <div class="input-group">
                      <label class="col-4 col-form-label">Helium Release Group *</label>
                      <input
                        v-model="releaseGroup"
                        name="releaseGroup"
                        class="form-control"
                        type="text"
                        placeholder="Helium Release Group"
                        >
                    </div>
                    <small class="form-text text-muted text-left col-sm-4">The Helium product name used to filter Helium apps for a release upgrade. Eg. Vouchering</small>
                  </div>
                  <div class="form-group">
                    <div class="input-group">
                      <label class="col-4 col-form-label">Helium Release Name *</label>
                      <input
                        v-model="releaseName"
                        name="releaseName"
                        class="form-control"
                        type="text"
                        placeholder="Helium Release Name"
                        >
                    </div>
                    <small class="form-text text-muted text-left col-sm-4"> Syntax: {product} - {YYYYMMDD}</small>
                  </div>
                  <div class="form-group">
                    <div class="input-group">
                      <label class="col-4 col-form-label">Deployment Date *</label>
                      <flat-pickr
                        v-model="selectedDate"
                        placeholder="Deployment Date"
                        :config="config"
                        type="date"
                        name="deploymentDate">
                      </flat-pickr>
                      <div class="input-group-btn">
                          <button class="btn btn-default" type="button" title="Toggle" data-toggle>
                            <i class="fa fa-calendar">
                              <span aria-hidden="true" class="sr-only">Toggle</span>
                            </i>
                          </button>
                      </div>
                    </div>
                  </div> 
                  <div class="form-group">
                      <div class="input-group">
                        <label class="col-4 col-form-label">Instructions</label>
                         <textarea 
                           class="form-control"
                           placeholder="Deployment Instructions here" 
                           :rows="5" 
                           v-model="instructions"
                           name="instructions"></textarea>
                      </div>
                      <small class="form-text text-muted text-left col-sm-4">Eg. Does it require a Journey deployment? Are there post sql scripts? What user role is required to create the release? etc.</small>
                  </div>
            </tab-content>
            <tab-content title="Confirmation">           
              <ul class="list-group break-word">
                <li class="list-group-item justify-content-between">
                  <label class="col-form-label">Dev Team</label>
                  <span class="info-form col-12">{{this.selectedTeam}}</span>
                </li>
                <li class="list-group-item justify-content-between">
                   <label class="col-form-label">Jira Project</label>
                  <span class="info-form col-12">{{this.selectedProject}}</span>
                </li>
                <li class="list-group-item justify-content-between">
                  <label class="col-form-label">Helium App Names</label>
                  <span class="info-form col-12">{{this.selectedAppNames}}</span>
                </li>
                <li class="list-group-item justify-content-between">
                  <label class="col-form-label">Helium App IDs</label>
                  <span class="info-form col-12">{{this.selectedAppIds}}</span>
                </li>
                <li class="list-group-item justify-content-between">
                  <label class="col-form-label">Helium App Schemas</label>
                  <span class="info-form col-12">{{this.selectedAppSchemas}}</span>
                </li>
                <li class="list-group-item justify-content-between">
                  <label class="col-form-label">Datasource</label>
                  <span class="info-form col-12">{{this.selectedDataSource}}</span>
                </li>
                <li class="list-group-item justify-content-between">
                  <label class="col-form-label">Helium Release Group</label>
                  <span class="info-form col-12">{{this.releaseGroup}}</span>
                </li>
                <li class="list-group-item justify-content-between">
                  <label class="col-form-label">Helium Release Name</label>
                  <span class="info-form col-12">{{this.releaseName}}</span>
                </li>
                <li class="list-group-item justify-content-between">
                  <label class="col-form-label">Bitbucket URL</label>
                  <span class="info-form col-12">{{this.releaseTag}}</span>
                </li>
                <li class="list-group-item justify-content-between">
                  <label class="col-form-label">Deployment Instructions</label>
                  <span class="info-form col-12">{{this.instructions}}</span>
                </li>
                <li class="list-group-item justify-content-between">
                  <label class="col-form-label">Deployment Date</label>
                  <span class="info-form col-12">{{this.selectedDate}}</span>
                </li>
              </ul>
            </tab-content>
              <div v-if="errorMsg">
                 <span class="error">{{errorMsg}}</span>
              </div>
        </form-wizard>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" name="button" @click="closeForm">Close</button>
      </div>
    </modal>
    <modal :show.sync="modalResolveShow" :backdrop="modalBackdrop" effect="zoom" large>
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">{{modalTitle}}</h4>
      </div>
      <div slot="modal-body" class="modal-body">
        <div class="form-group">
          Are you sure you want to resolve this schedule ?
        </div>
        <div class="form-group">
            <div class="input-group">
              <label class="col-4 col-form-label text-danger">Enter RESOLVE in capital letters</label>
              <input v-model="modalResolveConfirmInput" class="form-control" type="text">
            </div>
        </div>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" v-on:click="closeModalBtnClick">Close</button>
        <button type="button" class="btn btn-primary" @click="resolveSchedule" :disabled="resolveDisabled">Resolve</button>
      </div>
    </modal>
    <div class="row">
      <div class="col">
          <vue-good-table
            ref="deployments"
            title="Scheduled Deployments"
            :columns="deploymentColumns"
            :rows="deployments"
            styleClass="vgt-table striped bordered table-hover"
            :sort-options="{
              enabled: true,
              initialSortBy: {field: 'deploymentDate', type: 'desc'}
            }"
            :search-options="{ enabled: true }"
            :paginationOptions="{ enabled: true }">
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'deploymentDate'">{{ props.row.deploymentDate }}</span>
              <span v-if="props.column.field == 'team'">{{ props.row.team }}</span>
              <span v-if="props.column.field == 'jiraProject'">{{ props.row.jiraProject }}</span>
              <span v-if="props.column.field == 'appNames'">{{ props.row.appNames }}</span>
              <span v-if="props.column.field == 'appSchemas'">{{ props.row.appSchemas }}</span>
              <span v-if="props.column.field == 'releaseName'">{{ props.row.releaseName }}</span>
              <span v-if="props.column.field == 'releaseGroup'">{{ props.row.releaseGroup }}</span>
              <span v-if="props.column.label == 'Actions'">
                <div class="btn-group text-right" role="group">
                  <button type="button" class="btn btn-info" v-on:click="viewSchedule(props.row)">
                    <i class="fas fa-info-circle"></i> View
                  </button>
                  <button type="button" class="btn btn-warning" v-on:click="updateSchedule(props.row)">
                    <i class="fas fa-edit"></i> Update
                  </button>
                  <button type="button" class="btn btn-success" v-on:click="resolveBtnClick(props.row)">
                    <i class="fas fa-minus-circle"></i> Resolve
                  </button>
                </div>
              </span>
            </template>
          </vue-good-table>
      </div>
    </div>
    <div class="row" v-if="loading">
      <div class="col d-flex justify-content-center">
        <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
      </div>
    </div>
  </div>
</template>
<script>
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.min.css'
  import { modal } from 'vue-strap'
  export default {
    name: 'Deployments',
    components: {
      Loading,
      modal
    },
    data () {
      return {
        wizardTitle: '',
        modalTitle: '',
        modalInfoShow: false,
        selection: null,
        mergeBtnDisabled: false,
        loading: false,
        success: false,
        alertDuration: 3000,
        showSpinner: false,
        showForm: false,
        isEdit: false,
        modalBackdrop: false,
        loadingWizard: false,
        errorMsg: null,
        count: 0,
        dataSources: [],
        teams: [],
        jiraProjects: [],
        deployments: [],
        heliumApps: [],
        selectedAppIds: [],
        selectedAppSchemas: [],
        selectedAppNames: [],
        selectedDate: null,
        selectedDataSource: null,
        selectedTeam: null,
        selectedProject: null,
        releaseName: '',
        releaseTag: '',
        releaseDescription: '',
        instructions: '',
        releaseGroup: '',
        scheduleToBeResolved: null,
        deploymentScheduleRequestId: 'null',
        modalResolveShow: false,
        modalResolveConfirmInput: '',
        resolveDisabled: true,
        date: 'today',
        config: {
          wrap: true, // set wrap to true when using 'input-group'
          altInput: true,
          enableTime: true,
          defaultHour: 18,
          defaultMinute: 0,
          enableSeconds: true,
          minDate: new Date(),
          disable: [
            function (date) {
              return (date.getDay() === 0 || date.getDay() === 6 || date.getDay() === 6)
            }
          ]
        },
        deploymentColumns: [
          {
            label: 'Deployment Date',
            field: 'deploymentDate',
            type: 'datetime',
            filterable: true
          },
          {
            label: 'Team',
            field: 'team',
            filterable: true
          },
          {
            label: 'Project',
            field: 'jiraProject',
            filterable: true
          },
          {
            label: 'Helium Apps',
            field: 'appNames',
            filterable: true
          },
          {
            label: 'Schemas',
            field: 'appSchemas',
            filterable: true
          },
          {
            label: 'Release Name',
            field: 'releaseName',
            filterable: true
          },
          {
            label: 'Release Group',
            field: 'releaseGroup',
            filterable: true
          },
          {
            label: 'Actions',
            field: 'actions'
          }
        ],
        heliumAppColumns: [
          {
            label: 'Helium App',
            field: 'name',
            filterable: true
          },
          {
            label: 'App ID',
            field: 'id',
            filterable: true
          }
        ]
      }
    },
    methods: {
      validateStep1: function () {
        let vm = this
        return new Promise((resolve, reject) => {
          if (!vm.selectedDataSource) {
            reject('Please select a data source')
          }
          if (!vm.selectedTeam) {
            reject('Please select a team')
          }
          if (!vm.selectedProject) {
            reject('Please select a JIRA Project')
          }
          if (vm.selectedAppIds.length < 1) {
            reject('Please select atleast one Helium App.')
          }
          resolve(true)
        })
      },
      validateStep2: function () {
        let vm = this
        return new Promise((resolve, reject) => {
          if (!vm.releaseTag.startsWith('https://bitbucket.org/mezzanineapps/')) {
            reject('This URL is invalid. It does not begin with "https://bitbucket.org/mezzanineapps/". Please enter a valid Bitbucket URL containing the tag to release.')
          }
          if (!vm.releaseTag.includes('/commits/tag/')) {
            reject('This URL does not contain the tag. Please enter a valid Bitbucket URL containing the tag to release.')
          }
          if (!vm.releaseName) {
            reject('Please enter a Release Name')
          }
          if (!vm.releaseGroup) {
            reject('Please enter a Release Group')
          }
          if (!vm.selectedDate) {
            reject('Please select a Deployment Date.')
          }
          resolve(true)
        })
      },
      setLoading: function (value) {
        this.loadingWizard = value
      },
      handleValidation: function (isValid, tabIndex) {
        console.log('Tab: ' + tabIndex + ' valid: ' + isValid)
      },
      handleErrorMessage: function (errorMsg) {
        this.errorMsg = errorMsg
      },
      pingDatabase: function (dataSource) {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/ping-database'
        var config = {}
        config['environment'] = vm.$parent.environment.name
        config['dataSource'] = dataSource
        vm.loading = true
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.loading = false
            var element = {}
            element['heliumDataSourceName'] = dataSource.heliumDataSourceName
            element['response'] = response.data.response
            element['dataSource'] = dataSource
            vm.dataSources.push(element)
          })
          .catch(function (error) {
            vm.loading = false
            let obj = {
              title: 'Problem retrieving Ping to Database.',
              message: error.response,
              type: 'error'
            }
            vm.$Simplert.open(obj)
          })
      },
      getDatabaseServers: function () {
        let vm = this
        vm.$parent.environment.dataSources.forEach(function (key) {
          vm.pingDatabase(key)
        })
      },
      getTeams: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/deployment/teams'
        vm.axios.get(endpoint)
        .then(function (response) {
          vm.teams = response.data
        })
        .catch(function (error) {
          vm.loading = false
          let obj = {
            title: 'Problem retrieving Teams.',
            message: error.response,
            type: 'error'
          }
          vm.$Simplert.open(obj)
        })
      },
      getJiraProjects: function (team) {
        var teamParam = team.replace(/\s+/g, '')
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/deployment/jira-project/' + teamParam
        vm.axios.get(endpoint)
        .then(function (response) {
          vm.jiraProjects = response.data
        })
        .catch(function (error) {
          vm.loading = false
          let obj = {
            title: 'Problem retrieving JIRA Projects.',
            message: error.response,
            type: 'error'
          }
          vm.$Simplert.open(obj)
        })
      },
      getHeliumApps: function (team, jiraProject) {
        var teamParam = team.replace(/\s+/g, '')
        var projectParam = jiraProject.replace(/\s+/g, '')
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/deployment/apps/'
        var config = {}
        config['environment'] = vm.$parent.environment.name
        config['dataSource'] = vm.selectedDataSource
        config['team'] = teamParam
        config['jiraProject'] = projectParam
        vm.axios.post(endpoint, config)
        .then(function (response) {
          vm.heliumApps = response.data
          var selectAll = {}
          if (vm.isEdit) {
            selectAll['selected'] = true
          } else {
            selectAll['selected'] = false
          }
          selectAll['selectedRows'] = vm.heliumApps
          vm.onSelectAll(selectAll)
        })
        .catch(function (error) {
          vm.loading = false
          let obj = {
            title: 'Problem retrieving Helium Apps.',
            message: error.response,
            type: 'error'
          }
          vm.$Simplert.open(obj)
        })
      },
      onRowClick: function (params) {
        let index = this.selectedAppIds.indexOf(params.row.id)
        let exists = index !== -1
        if (params.selected) {
          if (!exists) {
            this.selectedAppIds.push(params.row.id)
            this.selectedAppSchemas.push(params.row.schemaName)
            this.selectedAppNames.push(params.row.name)
          }
        } else {
          if (exists) {
            this.selectedAppIds.splice(index, 1)
            this.selectedAppSchemas.splice(index, 1)
            this.selectedAppNames.splice(index, 1)
          }
        }
      },
      onSelectAll: function (params) {
        let vm = this
        let selectedAppIdsTmp = vm.selectedAppIds
        vm.selectedAppIds = []
        vm.selectedAppNames = []
        vm.selectedAppSchemas = []
        params.selectedRows.forEach(function (key) {
          let index = selectedAppIdsTmp.indexOf(key.id)
          if (params.selected) {
            if (vm.isEdit && index >= 0) {
              key.vgtSelected = true
              vm.selectedAppIds.push(key.id)
              vm.selectedAppNames.push(key.name)
              vm.selectedAppSchemas.push(key.schemaName)
            } else {
              key.vgtSelected = false
              vm.selectedAppIds.push(key.id)
              vm.selectedAppNames.push(key.name)
              vm.selectedAppSchemas.push(key.schemaName)
            }
          }
        })
      },
      newForm: function () {
        let vm = this
        vm.selected = null
        vm.wizardTitle = 'Schedule a Helium Deployment'
        vm.resetFilters()
        vm.$refs.heliumAppsTable.resetTable()
        vm.$refs.deploymentWizard.reset()
        vm.isEdit = false
        vm.showForm = true
        vm.resetFields()
      },
      closeForm: function () {
        let vm = this
        vm.showForm = false
        vm.resetFields()
      },
      resetFields: function () {
        let vm = this
        vm.mergeBtnDisabled = false
        vm.deploymentDate = null
        vm.releaseName = null
        vm.selectedDataSource = null
        vm.selectedTeam = null
        vm.selectedProject = null
        vm.selectedAppIds = []
        vm.selectedAppNames = []
        vm.selectedAppSchemas = []
        vm.releaseTag = null
        vm.releaseGroup = null
        vm.releaseName = null
        vm.releaseDescription = null
        vm.selectedDate = null
        vm.instructions = null
        vm.deploymentScheduleRequestId = 'null'
      },
      resetFilters: function () {
        let vm = this
        vm.selectedTeam = null
        vm.selectedProject = null
        vm.selectedAppSchemas = []
        vm.selectedAppNames = []
        vm.getTeams()
      },
      updateSchedule: function (row) {
        let vm = this
        vm.wizardTitle = 'Update a Helium Deployment Schedule'
        vm.selected = row
        vm.$refs.deploymentWizard.reset()
        vm.isEdit = true
        vm.selectedDataSource = row.dataSource
        vm.selectedTeam = row.team
        vm.selectedProject = row.jiraProject
        vm.selectedDate = row.deploymentDate
        vm.selectedAppIds = row.appIds
        vm.selectedAppSchemas = row.appSchemas
        vm.selectedAppNames = row.appNames
        vm.releaseTag = row.releaseTag
        vm.releaseGroup = row.releaseGroup
        vm.releaseName = row.releaseName
        vm.instructions = row.instructions
        vm.deploymentScheduleRequestId = row.id
        vm.showForm = true
      },
      modalInfoClose: function () {
        let vm = this
        vm.modalInfoShow = false
        vm.selection = null
      },
      viewSchedule: function (selection) {
        let vm = this
        vm.modalInfoShow = true
        vm.selection = selection
      },
      mergeSchedule: function () {
        let vm = this
        vm.mergeBtnDisabled = false
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/deployment/merge/' + vm.deploymentScheduleRequestId
        var dateStr = vm.selectedDate
        var isoDateStr = dateStr.replace(' ', 'T')
        var teamStr = vm.selectedTeam
        var tagStr = vm.releaseTag.split('tag/').pop()
        if (vm.instructions === null) {
          vm.instructions = 'None'
        }
        var config = {}
        config['team'] = teamStr
        config['jiraProject'] = vm.selectedProject
        config['environment'] = vm.$parent.environment.name
        config['dataSource'] = vm.selectedDataSource
        config['appSchemas'] = vm.selectedAppSchemas
        config['appNames'] = vm.selectedAppNames
        config['appIds'] = vm.selectedAppIds
        config['releaseTag'] = vm.releaseTag
        config['releaseName'] = vm.releaseName
        config['releaseGroup'] = vm.releaseGroup
        config['releaseDescription'] = tagStr
        config['scheduleStatus'] = 'MERGE'
        config['portalUser'] = vm.$parent.username
        config['instructions'] = vm.instructions
        config['deploymentDate'] = isoDateStr
        vm.loading = true
        vm.axios.post(endpoint, config)
        .then(function (response) {
          vm.loading = false
          vm.closeForm()
          vm.getSchedules()
          let obj = {
            title: 'Deployment Schedule has been updated.',
            message: response.data,
            type: 'success'
          }
          vm.$Simplert.open(obj)
        })
        .catch(function (error) {
          vm.loading = false
          let obj = {
            title: 'Problem merging Deployment Schedule.',
            message: error.response,
            type: 'error'
          }
          vm.$Simplert.open(obj)
        })
      },
      closeModalBtnClick: function () {
        this.modalResolveShow = false
        this.scheduleToBeResolved = null
        this.modalResolveConfirmInput = ''
      },
      resolveBtnClick: function (row) {
        this.modalTitle = 'Confirm resolve on Scheduled Deployment: ' + row.releaseName
        this.modalResolveShow = true
        this.scheduleToBeResolved = row.id
      },
      resolveSchedule: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/deployment/resolve/' + this.scheduleToBeResolved
        vm.loading = true
        vm.axios.post(endpoint)
          .then(function (response) {
            vm.loading = false
            vm.getSchedules()
            vm.closeModalBtnClick()
            let obj = {
              title: 'Resolved Deployment Schedule',
              message: response.data,
              type: 'success'
            }
            vm.$Simplert.open(obj)
          })
          .catch(function (error) {
            console.log(error)
            vm.loading = false
            let obj = {
              title: 'Problem resolving Deployment Schedule.',
              message: error.response,
              type: 'error'
            }
            vm.$Simplert.open(obj)
          })
      },
      getSchedules: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/deployment/list'
        vm.loading = true
        vm.axios.get(endpoint)
        .then(function (response) {
          vm.loading = false
          vm.deployments = response.data
        })
        .catch(function (error) {
          vm.loading = false
          let obj = {
            title: 'Problem retrieving Deployment Schedules.',
            message: error.response,
            type: 'error'
          }
          vm.$Simplert.open(obj)
        })
      }
    },
    created () {
      let vm = this
      vm.getDatabaseServers()
      vm.getTeams()
      vm.getSchedules()
      vm.resetFields()
      window.addEventListener('keydown', function (e) {
        if (e.keyCode === 27) {
          vm.closeForm()
          vm.modalInfoClose()
          vm.resetFilters()
        }
      })
    },
    watch: {
      'modalResolveConfirmInput': function (newValue) {
        if (newValue === 'RESOLVE') {
          this.resolveDisabled = false
        } else {
          this.resolveDisabled = true
        }
      },
      'selectedDataSource': function (val, oldVal) {
        if (val && !(this.isEdit)) {
          this.resetFilters()
        }
      },
      'selectedTeam': function (val, oldVal) {
        if (val) {
          this.getJiraProjects(val)
        }
      },
      'selectedProject': function (val) {
        if (val) {
          this.getHeliumApps(this.selectedTeam, val)
        }
      },
      'selectedAppIds': function (val) {
        console.log(val)
      }
    }
}
</script>

<style scoped>

.help.is-danger {
  color: #ff3860;
}

.help {
  display: block;
  font-size: 14px;
  margin-top: 5px;
  align-items: flex-end;
}

.input.is-danger, .textarea.is-danger {
  border-color: #ff3860;
}

#deployment-info {
  margin-top: 10px;
}

.flatpickr-calendar, .flatpickr-calendar.open {
  z-index: 99999999;
}

.card-block-watermark {
  font-size: 2rem;
  position: absolute;
  bottom: 5px;
  right: 5px;
  opacity: 0.3;
}

.word-wrap {
    word-wrap: break-word;
}

span.error{
  color:#e74c3c;
  font-size:15px;
  padding-bottom: 15px;
  display:flex;
  justify-content:center;
}

span.info-form{
  word-wrap: break-word;
  background-color: lightgrey; 
  padding: 10px;
}

</style>



// WEBPACK FOOTER //
// Deployments.vue?45ae7454